import store from '@/store'
import router from '@/router'
import { startPageDealed } from '@/api/common/startpageauth'
import { Message } from 'element-ui'

// iframe中控制路由的变化
function receiveMessageFromIframePage(event) {
  if (event.data.data) {
    if (event.data.data.includes('haveparams')) {
      router.push({
        path: `/iframe/${encodeURIComponent(
          event.data.name
        )}/${encodeURIComponent(event.data.path)}`
      })
    } else if (event.data.data.includes('iframefullscreen')) {
      router.push({
        path: `/iframe-fullscreen/${encodeURIComponent(
          event.data.name
        )}/${encodeURIComponent(event.data.path)}`
      })
    } else if (event.data.data.includes('ythRouter')) {
      router.push({
        path: event.data.path
      })
    } else if (event.data.data.includes('closeWindow')) {
      // 首页启动页
      if (event.data.flag) {
        startPageDealed()
          .then(() => {
            store.state.auth.isEnabled = false
          })
          .catch(errMsg => Message.error(errMsg))
      }
    }
  }
}
export default () => {
  window.addEventListener('message', receiveMessageFromIframePage, false)
}
